import { NgModule } from '@angular/core';
import { withSentryBrowserProviders } from './initialization';

@NgModule({
  providers: [withSentryBrowserProviders()],
})
export class SentryBrowserModule {}
